import { __awaiter, __generator } from "tslib";
import { execFile, execFileSync } from 'child_process';
var createLoadError = function (error) { return new Error('Unable to load file from git: ' + error); };
var createCommand = function (_a) {
    var ref = _a.ref, path = _a.path;
    return ['show', ref + ":" + path];
};
/**
 * @internal
 */
export function loadFromGit(input) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            execFile('git', createCommand(input), { encoding: 'utf-8', maxBuffer: 1024 * 1024 * 1024 }, function (error, stdout) {
                                if (error) {
                                    reject(error);
                                }
                                else {
                                    resolve(stdout);
                                }
                            });
                        })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    error_1 = _a.sent();
                    throw createLoadError(error_1);
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * @internal
 */
export function loadFromGitSync(input) {
    try {
        return execFileSync('git', createCommand(input), { encoding: 'utf-8' });
    }
    catch (error) {
        throw createLoadError(error);
    }
}
//# sourceMappingURL=load-git.js.map